import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { ActionColor, CheckBoxAction, TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { MasterSolutionDetailModel } from 'src/app/models/preliminaries/master-solution-detail.model';
import { MasterSolutionModel } from 'src/app/models/preliminaries/master-solution.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ArticleSelectionTableModel } from 'src/app/models/tables/archive/article-selection-table.model';
import { MasterSolutionDetailSelectTableModel } from 'src/app/models/tables/preliminaries/master-solution-detail-select-table.model';
import { MasterSolutionDetailService } from 'src/app/services/preliminaries/master-solution-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';
import { ImportMasterSolutionDetailComponent } from '../import-master-solution-detail/import-master-solution-detail.component';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { MasterSolutionEnums } from 'src/app/enum/master-solution-Enums';

@Component({
  selector: 'app-master-solution-detail',
  templateUrl: './master-solution-detail.component.html',
  styleUrls: ['./master-solution-detail.component.scss'],
  standalone: false
})
export class MasterSolutionDetailComponent implements OnInit {

  @ViewChild('articleSelection') articleForSelectionModalComponent?: CustomModalComponent | null = null;
  @ViewChild('importDetailModal') importDetailModalComponent?: CustomModalComponent | null = null;
  @Input() disabledForm: boolean = false;
  @Input() masterSolutionModel: MasterSolutionModel = new MasterSolutionModel();
  @Input() permissionsUser: OptionWindowModel[] = [];
  @Input() permissionUpdatable: boolean = false;
  @Input() userAuthenticated: UserModel = new UserModel();
  @Output() emitQuantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  ascendantArticle: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortArticle: string | null = null;
  component = CustomTableSelectComponent;
  componentImportDetailModal = ImportMasterSolutionDetailComponent;
  dataArticle: PagedResponseModel<ArticleSelectionTableModel> = new PagedResponseModel<ArticleSelectionTableModel>();
  detailData: PagedResponseModel<MasterSolutionDetailSelectTableModel> = new PagedResponseModel<MasterSolutionDetailSelectTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = false;
  filters: ColumnResponseModel[] = [];
  filtersArticle: ColumnResponseModel[] = [];
  headerArticle: ColumnResponseModel[] = [];
  inputsForArticlesSelection$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: false,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
    actions: [],
  });
  inputsForImportDetailModals$ = new BehaviorSubject<any>({
    masterSolutionId: 0,
  });
  isFormView: boolean = false;
  limit: number = 10;
  limitArticle: number = 5;
  masterSolutionDetail: MasterSolutionDetailModel = new MasterSolutionDetailModel();
  masterSolutionDetails: MasterSolutionDetailModel[] = [];
  output$ = new Subject<any>();
  page: number = 1;
  pageArticle: number = 1;
  quantityDetails: number = 0;
  subscription: Subscription;
  tableActions: TableAction[] = [];

  constructor(private masterSolutionDetailService: MasterSolutionDetailService,
    private toastHandlerService: ToastHandlerService) { }

  async ngOnInit() {
    await this.getColumnsForDetailCapture();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeArticleSelection(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeArticleSelection(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    const disabledForm = changes["disabledForm"];
    const masterSolutionModel = changes["masterSolutionModel"];
    this.disabledButton = this.disabledForm || this.masterSolutionModel.masterSolutionId === 0;
    if (masterSolutionModel && !masterSolutionModel.firstChange) {
      this.clearSelectionTrigger++;
      this.getFormView(false);
      this.getMasterSolutionDetailsForCapture();
    }
    if (disabledForm) {
      this.tableActions = this.disabledForm ? [] : this.getDefaultActions();
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async deleteDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;
    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle de la solución?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.masterSolutionDetailService.deleteSomeDetailsAsync(selectedIds));
        this.toastHandlerService.showToast('success', 'El detalle de la solución fue eliminado exitosamente.');
        this.clearSelectionTrigger++;
        await this.getMasterSolutionDetailsForCapture();
      } catch (error) {
        console.error('Error al eliminar los detalles de la solución.', error);
      }
    }
  }

  async getArticlesForSelection() {
    try {
      this.dataArticle = await firstValueFrom(this.masterSolutionDetailService.getArticlesForDetails(this.pageArticle, this.limitArticle,
        this.columnSortArticle, this.ascendantArticle, this.filtersArticle));
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener la lista de los artículos.', error);
    }
  }

  async getColumnsForArticleSelection() {
    try {
      if (this.headerArticle.length != 0) return;
      this.headerArticle = await firstValueFrom(this.masterSolutionDetailService.getColumnsForArticles());
    } catch (error) {
      console.error('Error al buscar las columnas para la selección de artículos.', error);
    }
  }

  async getColumnsForDetailCapture() {
    try {
      this.detailHeader = await firstValueFrom(this.masterSolutionDetailService.getColumnsMasterSolutionDetails());
    } catch (error) {
      console.error('Error al obtener las columnas del detalle para la captura.', error);
    }
  }

  getDefaultActions(): TableAction[] {
    return [
      {
        label: 'Editar',
        icon: 'pi pi-pencil',
        action: 'edit'
      }
    ];
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getMasterSolutionDetailById(detailId: number) {
    try {
      const response = await firstValueFrom(this.masterSolutionDetailService.getByIdAsync(detailId));
      if (response) {
        this.masterSolutionDetail = response;
        this.getFormView(true);
      }
    } catch (error) {
      console.error('Error al obtener el detalle de la solución.', error);
    }
  }

  async getMasterSolutionDetailByKeys(articleId: number): Promise<MasterSolutionDetailModel> {
    try {
      const response = await firstValueFrom(this.masterSolutionDetailService.getMasterSolutionDetailByKeys(this.masterSolutionModel.masterSolutionId, articleId));
      this.getFormView(true);
      return response;
    } catch (error) {
      console.error('Error al obtener el detalle del solución por clave.', error);
      return new MasterSolutionDetailModel();
    }
  }

  async getMasterSolutionDetailsForCapture() {
    try {
      this.detailData = await firstValueFrom(this.masterSolutionDetailService.getMasterSolutionDetailsForSelection(this.page, this.limit,
        this.columnSort, this.ascendant, this.filters, this.masterSolutionModel.masterSolutionId));
      this.quantityDetails = this.detailData.totalItems;
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al obtener los detalles de la solución para la captura de datos.', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    if (selectedItem.length == 1) {
      const [{ articleId }] = selectedItem;
      const response = await this.getMasterSolutionDetailByKeys(articleId);
      this.masterSolutionDetail = response;
    } else {
      const newDetails = selectedItem.map((element: {
        orderId: number,
        articleId: number, rentalUnitId: number
      }) => {
        const newMasterSolutionDetail = new MasterSolutionDetailModel();
        newMasterSolutionDetail.masterSolutionId = this.masterSolutionModel.masterSolutionId;
        newMasterSolutionDetail.articleId = element.articleId;
        return newMasterSolutionDetail;
      });
      this.masterSolutionDetails = newDetails;
    }
  }

  async onAction(event: { action: string, item?: MasterSolutionDetailSelectTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit') {
      await this.getMasterSolutionDetailById(event.item!.id);
    }
    if (event.action === 'bulk-delete' && event.selectedItems) {
      await this.deleteDetail(event.selectedItems);
    }
  }

  async onFilterChangeArticleSelection(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);
    this.filtersArticle = this.removeDuplicates(filters);
    this.filtersArticle.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    this.getMasterSolutionDetailsForCapture();
  }

  async onPageChangeArticleSelection(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageArticle = event.page;
    this.limitArticle = event.pageSize;
    this.columnSortArticle = event.sortField || null;
    this.ascendantArticle = event.sortOrder === 1;
    await this.getArticlesForSelection();
  }

  async openArticleSelectionModal() {
    this.filtersArticle = [];
    await this.getColumnsForArticleSelection();
    await this.getArticlesForSelection();
    this.updateInputs();
    this.articleForSelectionModalComponent && this.articleForSelectionModalComponent.show();
  }

  openImportDetailModal() {
    const isAdminWithImportPermission = this.userAuthenticated.profileUser.code === ProfileUserEnums.administrador &&
      this.permissionsUser.some(x => x.code === OptionWindow.Importar);
    if (this.quantityDetails > 0) {
      this.toastHandlerService.showToast('warning', `No se puede importar si la solución ya tiene detalle.`);
      return;
    }
    if (isAdminWithImportPermission) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para importar detalles de una solución,
        comuniquese con el administrador del sistema.`);
      return;
    }
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para la edición de soluciones.
        Comuníquese con el administrador del sistema.`);
      return;
    }
    if (this.masterSolutionModel.masterSolutionId === 0) {
      this.toastHandlerService.showToast('warning', `La solución aún no se ha guardado.`);
      return;
    }
    if (this.masterSolutionModel.masterSolutionState !== MasterSolutionEnums.open) {
      this.toastHandlerService.showToast('warning', 'La solución debe estar en estado "Abierto".');
      return;
    }
    this.inputsForImportDetailModals$.next({ masterSolutionId: this.masterSolutionModel.masterSolutionId });
    this.importDetailModalComponent?.show();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersArticle = this.filtersArticle.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersArticle.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async reload(reload: any) {
    if (reload) {
      await this.getMasterSolutionDetailsForCapture();
    }
  }

  updateInputs() {
    this.inputsForArticlesSelection$.next({
      headers: this.headerArticle,
      data: this.dataArticle,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      limitPaginator: true,
      filters: this.filtersArticle,
      actions: [
        {
          label: 'Imágenes',
          icon: 'pi pi-image',
          action: 'view-image'
        }
      ]
    });
  }
}
